import axios from 'axios';

// Client-side funnel events, written to the same funnel_events table as the
// registration funnel through POST /track/funnel. The endpoint reads a form
// body (it sits outside the FOSRest zones, so a JSON body is never decoded),
// hence URLSearchParams: PHP expands metadata[key]=value into the array the
// controller expects. Metadata stays flat, one level. Fire and forget.
export default function trackEvent(event, metadata = {}) {
  const body = new URLSearchParams({ event });
  Object.keys(metadata).forEach((key) => {
    if (metadata[key] !== undefined && metadata[key] !== null) body.append(`metadata[${key}]`, metadata[key]);
  });
  axios.post('/track/funnel', body, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(() => {});
}
